import { SHIPMENT_STATUSES } from '../../api/shipments/enums/shipment-statuses';

export const shipmentNotEditAbleStatuses = [
  SHIPMENT_STATUSES.DELIVERED,
  SHIPMENT_STATUSES.CLOSED,
  SHIPMENT_STATUSES.CANCELED
];